 <template>
  <div id="BrandSet" class="page-content">
    <!-- <div class="header"> -->
      <el-breadcrumb separator="/" style="line-height: 40px;">
        <el-breadcrumb-item>外部用户</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/externalUsers/BrandAccount' }">品牌方账号</el-breadcrumb-item>
        <el-breadcrumb-item>品牌设置</el-breadcrumb-item>
      </el-breadcrumb>
    <!-- </div> -->
    <div>
      <div class="titleFont">{{this.$route.query.companyname}}</div>
      <el-row>
        <el-col :span="24" class="theTitle" style="margin-top: 15px;margin-bottom: 15px;">
          <div style="font-size: 18px;color: #333333;display: flex;float: left;">
            <div class="iconDiv">
              .
            </div>
            监控相关权限设置
          </div>
          <span style="color: #479df0;float: right;cursor: pointer;" @click="Editor(5)"><i class="el-icon-edit-outline"></i>编辑</span>
        </el-col>
        <el-col :span="24">
          <el-card>
            <div style="float: left;width: 100%;border-bottom: 1px solid #F1F1F1;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                监控产品
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">监控产品数量上限(个)</div>
                <el-input v-model="productmonitorNumber" placeholder="请输入内容" class="smallDiv" size="small" :disabled="settingDisabled"></el-input>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">监控频次上限</div>
                <el-select v-model="productmonitorFrequency" placeholder="请选择" size="small" :disabled="settingDisabled" style="width: 80%;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">支持监控平台</div>
                <el-select v-model="productmonitorPlatform" multiple placeholder="请选择" size="small" style="width: 80%;" :disabled="settingDisabled">
                  <el-option v-for="item in platformData" :label="item.dictName" :value="item.dictCode" v-show="item.pricename == 'main' && item.dictName != '唯品会' && item.dictName != '拼多多' && item.dictName != '其他'"></el-option>
                </el-select>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否具有监控快照</div>
                <el-radio v-model="productmonitorSnapshot" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
                <el-radio v-model="productmonitorSnapshot" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
              </div>
            </div>
            <div style="float: left;margin-top: 10px;width: 100%;border-bottom: 1px solid #F1F1F1;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                监控店铺
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">监控店铺数量上限(个)</div>
                <el-input v-model="shopmonitorNumber" placeholder="请输入内容" class="smallDiv" size="small" :disabled="settingDisabled"></el-input>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">监控频次上限</div>
                <el-select v-model="shopmonitorFrequency" placeholder="请选择" size="small" :disabled="settingDisabled" style="width: 80%;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">支持监控平台</div>
                <el-select v-model="shopmonitorPlatform" multiple placeholder="请选择" size="small" style="width: 80%;" :disabled="settingDisabled">
                  <el-option v-for="item in platformData" :label="item.dictName" :value="item.dictCode" v-show="item.pricename == 'main' && item.dictName != '唯品会' && item.dictName != '拼多多' && item.dictName != '其他'"></el-option>
                </el-select>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否具有监控快照</div>
                <el-radio v-model="shopmonitorSnapshot" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
                <el-radio v-model="shopmonitorSnapshot" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
              </div>
            </div>
            <div style="float: left;margin-top: 10px;width: 100%;border-bottom: 1px solid #F1F1F1;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                监控链接
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">监控链接数量上限(个)</div>
                <el-input v-model="singlelinkNumber" placeholder="请输入内容" class="smallDiv" size="small" :disabled="settingDisabled"></el-input>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">监控价格维度</div>
                <el-radio v-model="singlelinkDimensionality" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">标价</el-radio>
                <el-radio v-model="singlelinkDimensionality" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">标价&到手价</el-radio>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">支持监控平台</div>
                <el-select v-model="singlelinkPlatform" multiple placeholder="请选择" size="small" style="width: 80%;" :disabled="settingDisabled">
                  <el-option v-for="item in platformData" :label="item.dictName" :value="item.dictCode" v-show="item.pricename == 'main' && item.dictName != '唯品会' && item.dictName != '拼多多' && item.dictName != '其他'"></el-option>
                </el-select>
              </div>
              <div class="divbf" style="width: 80%;">
                <div style="margin-bottom: 8px;">是否具有监控快照</div>
                <el-radio v-model="singlelinkSnapshot" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
                <el-radio v-model="singlelinkSnapshot" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
              </div>
            </div>
            <div style="float: left;margin-top: 10px;width: 100%;margin-bottom: 20px;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                实时比价
              </div>
              <div>
                <div style="margin-bottom: 8px;">允许查价产品数量上限(个/天)</div>
                <el-input v-model="productcheckpriceNumber" placeholder="请输入内容" style="width: 26.4%;" size="small" :disabled="settingDisabled"></el-input>
              </div>
            </div>
            <div style="float: left;margin-top: 10px;width: 100%;margin-bottom: 20px;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                数据接口设置
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否使用api接口</div>
                <el-radio v-model="spiderId" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
                <el-radio v-model="spiderId" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否开启数据截图</div>
                <el-radio v-model="screenshotStatus" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
                <el-radio v-model="screenshotStatus" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否开启最优优惠</div>
                <el-radio v-model="couponstype" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
                <el-radio v-model="couponstype" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
              </div>
            </div>

            <div style="float: left;margin-top: 10px;width: 100%;margin-bottom: 20px;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                数据大屏
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否启用数据大屏</div>
                <el-radio v-model="dateplatformStatus" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
                <el-radio v-model="dateplatformStatus" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
              </div>
              <div class="divbf" v-if="dateplatformStatus == 1">
                <div style="margin-bottom: 8px;">支持数据大屏平台</div>
                <el-select v-model="dateplatform" multiple placeholder="请选择" size="small" style="width: 80%;" :disabled="settingDisabled">
                  <el-option v-for="item in platformData" :label="item.dictName" :value="item.dictCode" v-show="item.pricename == 'main'"></el-option>
                </el-select>
              </div>
            </div>

            <div style="float: left;margin-top: 10px;width: 100%;margin-bottom: 20px;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                控价数据分析
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否启用控价数据分析</div>
                <el-radio v-model="databoardStatus" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
                <el-radio v-model="databoardStatus" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
              </div>
            </div>

            <div style="float: left;margin-top: 10px;width: 100%;margin-bottom: 20px;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                账号活跃
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否开启账号活跃</div>
                <el-radio v-model="dataloginStatus" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
                <el-radio v-model="dataloginStatus" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
              </div>
            </div>

            <div style="float: left;margin-top: 10px;width: 100%;margin-bottom: 20px;">
              <div style="font-weight: 600;margin-bottom: 20px;">
                价格趋势
              </div>
              <div class="divbf">
                <div style="margin-bottom: 8px;">是否开启价格趋势</div>
                <el-radio v-model="majorproducts" label="0" size="small" style="margin-left: 10px;" :disabled="settingDisabled">否</el-radio>
                <el-radio v-model="majorproducts" label="1" size="small" style="margin-left: 10px;" :disabled="settingDisabled">是</el-radio>
              </div>
            </div>

            <el-button v-show="businessSettingShow" type="primary" size="small" style="margin-right: 15px;" @click="businessSetting(1)">确认</el-button>
            <el-button v-show="businessSettingShow" type="TheCustom" size="small" @click="businessSetting(2)" >取 消</el-button>
          </el-card>
        </el-col>
       <el-col :span="24"  class="theTitle" style="margin-top: 15px;margin-bottom: 15px;">
         <div style="font-size: 18px;color: #333333;display: flex;float: left;">
           <div class="iconDiv">
             .
           </div>
           BRM业务专属设置
         </div>
         <span style="color: #479df0;float: right;cursor: pointer;" @click="Editor(3)"><i class="el-icon-edit-outline"></i>编辑</span>
       </el-col>
       <el-card style="clear: both;">
         <el-row>
           <el-col :span="24" class="theTitle">
             专属域名：
             <el-input placeholder="请输入内容" v-model="domainname" style="width: 40%;" :disabled="this.domainDisble" size="small" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;">
               <template slot="prepend">Https://</template>
               <template slot="append">olonger.com</template>
             </el-input>
           </el-col>
           <el-button v-show="this.brandshow" type="primary" size="small" style="margin-top: 16px;margin-right: 15px;" @click="domainNameUp(1)">确认</el-button>
           <el-button v-show="this.brandshow" type="TheCustom" size="small" @click="domainNameUp(2)" >取 消</el-button>
         </el-row>
       </el-card>

       <el-col :span="24"  class="theTitle" style="margin-top: 15px;margin-bottom: 15px;">
         <div style="font-size: 18px;color: #333333;display: flex;float: left;">
           <div class="iconDiv">
             .
           </div>
           品牌LOGO设置
         </div>
         <span style="color: #479df0;float: right;cursor: pointer;" @click="Editor(4)"><i class="el-icon-edit-outline"></i>编辑</span>
       </el-col>

       <el-card style="clear: both;">
         <el-row>
           <el-col :span="2"  class="theTitle" style="margin-bottom: 15px;">
             <span style="color: #666666;">
             登录页面Logo：
             </span>
             </el-dialog>
           </el-col>
           <el-col :span="6"  class="theTitle" style="margin-bottom: 15px;">
             <el-upload
               class="avatar-uploader"
               :action="UploadUrl()"
               :show-file-list="false"
               :on-success="handleAvatarSuccess"
               :before-upload="beforeAvatarUpload"
               :http-request="picRequest"
               :disabled="uploadDisabled"
               :on-remove="handleRemove">
               <i v-if="!imageUrl" class="el-icon-plus avatar-uploader-icon"></i>
               <img v-else :src="imageUrl" class="avatar">
               <div v-show="uploadDisabled == false">
                 <i @click.stop="photo(1)" v-show="imageUrl" class="el-icon-error" style="color: #d81e06;position: absolute;top: 0px;left: 155px;font-size: 24px;"></i>
               </div>
             </el-upload>
             <span style="color: #666666;">
               支持格式：PNG，尺寸：306*60
             </span>
           </el-col>
           <el-col :span="2"  class="theTitle" style="margin-bottom: 15px;">
             <span style="color: #666666;">
             导航展开Logo：
             </span>
             </el-dialog>
           </el-col>
           <el-col :span="6"  class="theTitle" style="margin-bottom: 15px;">
             <el-upload
               class="avatar-uploader"
               :action="UploadUrl()"
               :show-file-list="false"
               :on-success="handleAvatarSuccess2"
               :before-upload="beforeAvatarUpload2"
               :http-request="picRequest2"
               :disabled="uploadDisabled">
               <i v-if="!imageUrl2" class="el-icon-plus avatar-uploader-icon"></i>
               <img v-else :src="imageUrl2" class="avatar">
               <div v-show="uploadDisabled == false">
                 <i @click.stop="photo(2)" v-show="imageUrl2" class="el-icon-error" style="color: #d81e06;position: absolute;top: 0px;left: 155px;font-size: 24px;"></i>
               </div>
             </el-upload>
             <span style="color: #666666;">
               支持格式：PNG，尺寸：200*63
             </span>
           </el-col>
           <el-col :span="2"  class="theTitle" style="margin-bottom: 15px;">
             <span style="color: #666666;">
             导航收起Logo：
             </span>
             </el-dialog>
           </el-col>
           <el-col :span="6"  class="theTitle" style="margin-bottom: 15px;">
             <el-upload
               class="avatar-uploader"
               :action="UploadUrl()"
               :show-file-list="false"
               :on-success="handleAvatarSuccess3"
               :before-upload="beforeAvatarUpload3"
               :http-request="picRequest3"
               :disabled="uploadDisabled">
               <i v-if="!imageUrl3" class="el-icon-plus avatar-uploader-icon"></i>
               <img v-else :src="imageUrl3" class="avatar">
               <div v-show="uploadDisabled == false">
                 <i @click.stop="photo(3)" v-show="imageUrl3" class="el-icon-error" style="color: #d81e06;position: absolute;top: 0px;left: 155px;font-size: 24px;"></i>
               </div>
             </el-upload>
             <span style="color: #666666;">
               支持格式：PNG，尺寸：60*40
             </span>
           </el-col>
           <el-button v-show="this.logoshow" type="primary" size="small" style="margin-right: 15px;" @click="logo(1)">确认</el-button>
           <el-button v-show="this.logoshow" size="small" @click="logo(2)" type="TheCustom">取 消</el-button>
         </el-row>
       </el-card>

     </el-row>
   </div>
 </div>
</template>

<script>
 import axios from "axios";
 export default {
   data() {
     return {
       productmonitorFrequency: 0, //监控频次上限
       shopmonitorFrequency: 0, //监控频次上限
       productmonitorSnapshot: '1', //产品 是否具有监控快照
       shopmonitorSnapshot: '1', //产品 是否具有监控快照
       productmonitorPlatform: [], //产品 支持监控平台
       shopmonitorPlatform: [], //产品 支持监控平台
       productmonitorNumber: 0, //产品 监控产品数量
       shopmonitorNumber: 0, //产品 监控店铺数量
       productcheckpriceNumber: 10, //产品 查价数量
       productmonitorDimensionality: '0', //产品 监控价格维度
       singlelinkPlatform: [], //单链接 支持监控平台
       dateplatform: [], //数据大屏 支持监控平台
       
       singlelinkSnapshot: '1', //单链接 是否具有监控快照
       singlelinkDimensionality: '0', //单链接 监控价格维度
       spiderId: '0',
       dateplatformStatus: '0', // 关闭数据数据大屏
       databoardStatus: '0', // 关闭控价数据分析
       dataloginStatus: '0', // 关闭账号活跃
       majorproducts: '0', // 关闭价格趋势
       screenshotStatus: '0', //是否开启数据截图
       couponstype: '0', //是否开启最优优惠
       singlelinkNumber: 5, //单链接 监控产品数量上限
       businessSettingShow: false,
       platformData: [],
       imageUrl: '',
       imageUrl2: '',
       imageUrl3: '',
       imgUrl: '',
       brmkefu: [],
       brmkefu2: [],
       iprkefu: [],
       iprkefu2: [],
       jdaccount: [],
       jdaccount2: [],
       tbaccount2: [],
       JDcomplaiontId: [],
       tbaccount: [],
       ALcomplaiontId: [],
       validtimebrm: '',
       validtimeipr: '',
       version: '',
       dict: [],
       brmList: [],
       iprList: [],
       // alIPR: [], //阿里投诉账号
       // jdIPR: [], //京东投诉账号
       dialogImageUrl: '',
       dialogVisible: false,
       iprEditorshow: false,
       brmEditorshow: false,
       brandshow: false,
       logoshow: false,
       domainDisble: true,
       uploadDisabled: true,
       uploadDisabled2: true,
       uploadDisabled3: true,
       brmDisabled:true,
       settingDisabled:true,
       iprdisabled:true,
       noRepeatClick:false,
       domainname: '',
       options: [{
         value: 0,
         label: '1次/天'
       }, {
         value: 1,
         label: '2次/天'
       }],
       form: {
         name: '',
         region: '',
         date1: '',
         date2: '',
         delivery: false,
         type: [],
         resource: '',
         desc: ''
       }
     }
   },
   filters: {
     formatDate: function (value) {
       let date = new Date(value);
       let y = date.getFullYear();
       let MM = date.getMonth() + 1;
       MM = MM < 10 ? ('0' + MM) : MM;
       let d = date.getDate();
       d = d < 10 ? ('0' + d) : d;
       let h = date.getHours();
       h = h < 10 ? ('0' + h) : h;
       let m = date.getMinutes();
       m = m < 10 ? ('0' + m) : m;
       let s = date.getSeconds();
       s = s < 10 ? ('0' + s) : s;
       return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
     }
   },
   mounted() {
     this.selecthcmlogo();
     this.showBusiness();
     this.GetList();
     this.getIPRList();
     this.getBRMList();
     this.getTree();
     this.selectbmcCampaigntype();
   },
   methods: {
     selectbmcCampaigntype() {
       let params={
         bmcid: this.$route.query.bmcid,
       }
       fetch({
         url: "hcm/cus/selectbmcSetting",
         method: "get",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           this.productcheckpriceNumber = data.productcheckpriceNumber;
           this.productmonitorDimensionality = data.productmonitorDimensionality.toString();
           this.productmonitorFrequency = data.productmonitorFrequency;
           this.shopmonitorFrequency = data.shopmonitorFrequency;
           this.productmonitorNumber = data.productmonitorNumber;
           this.shopmonitorNumber = data.shopmonitorNumber;
           this.productmonitorSnapshot = data.productmonitorSnapshot.toString();
           this.shopmonitorSnapshot = data.shopmonitorSnapshot.toString();
           this.singlelinkDimensionality = data.singlelinkDimensionality.toString();
           this.spiderId = data.spiderId.toString();
           this.dateplatformStatus = data.dateplatformStatus.toString();
           this.databoardStatus = data.databoardStatus.toString();
           this.dataloginStatus = data.dataloginStatus.toString();
           this.majorproducts = data.majorproducts.toString();
           
           if (data.screenshotStatus) {
             this.screenshotStatus = data.screenshotStatus.toString();
           }
           if (data.couponstype) {
             this.couponstype = data.couponstype.toString();
           }
           this.singlelinkNumber = data.singlelinkNumber;
           this.singlelinkSnapshot = data.singlelinkSnapshot.toString();
           if (data.singlelinkPlatform == '') {
           } else {
             this.singlelinkPlatform = data.singlelinkPlatform.split(",");
           }

           if (data.dateplatform == '') {
           } else {
             this.dateplatform = data.dateplatform.split(",");
           }
           
           if (data.productmonitorPlatform == '') {
           } else {
             this.productmonitorPlatform = data.productmonitorPlatform.split(",");
           }
           if (data.shopmonitorPlatform == '') {
           } else {
             this.shopmonitorPlatform = data.shopmonitorPlatform.split(",");
           }

         } else {
           this.$message.error(res.message)
         }
       })
     },
     getTree() {
       let params={
         dictcode: 'platform',
         pricename: 'main',
       }
       fetch({
         url: "hcm/sys/GetList",
         method: "get",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           this.platformData = data;
         } else {
           this.$message.error(res.message)
         }
       })
     },
     photo(e) {
       if (e == 1) {
         this.imageUrl = ''
       } else if (e == 2){
         this.imageUrl2 = ''
       } else {
         this.imageUrl3 = ''
       }
     },
     UploadUrl() {
       return "hcm/hcmWorkOrder/headImgUpload";
     },
     handleRemove(file, fileList) {
       console.log(file, fileList);
     },
     getBRMList() {
       let params={
         departmentId: '2',
         keyword: '',
         checkedids: '',
       }
       fetch({
         url: "hcm/departmentin/getDepartmentLeaderList",
         method: "get",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           this.brmList = data
         } else {
           this.$message.error(res.message);
         }
       })
     },
     getIPRList() {
       let params={
         departmentId: '1',
         keyword: '',
         checkedids: '',
       }
       fetch({
         url: "hcm/departmentin/getDepartmentLeaderList",
         method: "get",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           this.iprList = data
         } else {
           this.$message.error(res.message);
         }
       })
     },
     iprAdd(e) {
       if (e == 1 ) {
         this.noRepeatClick = true
         var a;
         a = this.iprkefu.join(',');
         var b;
         b = this.ALcomplaiontId.join(',');
         var c;
         c = this.JDcomplaiontId.join(',');
         let params={
           bmcid: this.$route.query.id,
           validtime: this.$options.filters['formatDate'] (this.validtimeipr).substring(0,10),
           kefuids: a,
           ALcomplaiontId: b,
           JDcomplaiontId: c,
           oldALcomplaiontId: this.tbaccount,
           oldJDcomplaiontId: this.jdaccount,
           buyservice: 'ipr',
           version: this.version
         }
         fetch({
           // url: "hcm/cus/saveBrmByBmcid",
           url: "hcm/complaiont/saveBmcid",
           method: "post",
           params: params,
           noFormat: true,
           responseType: "text"
         }).then(result => {
           let res = JSON.parse(result);
           let {data}=res
           if(res.status == '10000'){
             this.noRepeatClick = false
             this.showBusiness();
             this.iprkefu = [];
             this.brmkefu = [];
             this.JDcomplaiontId = [];
             this.ALcomplaiontId = [];
             this.iprEditorshow = false
             this.iprdisabled = true
           } else {
             this.$message.error(res.message);
           }
         })
       } else {
         this.iprEditorshow = false
         this.iprdisabled = true
       }
     },
     brmAdd(e) {
       if (e == 1 ) {
         var a;
         a = this.brmkefu.join(',');
         let params={
           bmcid: this.$route.query.id,
           validtime: this.$options.filters['formatDate'] (this.validtimebrm).substring(0,10),
           kefuids: a,
           version: this.version
         }
         fetch({
           url: "hcm/cus/saveBrmByBmcid",
           method: "post",
           params: params,
           noFormat: true,
           responseType: "text"
         }).then(result => {
           let res = JSON.parse(result);
           let {data}=res
           if(res.status == '10000'){
             this.showBusiness();
             this.brmkefu = [];
             this.iprkefu = [];
             this.JDcomplaiontId = [];
             this.ALcomplaiontId = [];
             this.brmEditorshow = false
             this.brmDisabled = true
           } else {
             this.$message.error(res.message);
           }
         })
       } else {
         this.brmEditorshow = false
         this.brmDisabled = true
       }
     },
     logo(e) {
       if (e == 1) {
         this.logoshow = false
         this.uploadDisabled= true
         this.uploadDisabled2= true
         this.uploadDisabled3= true
         let params={
           bmcid: this.$route.query.id,
         }
         if (this.imageUrl) {
           params.loginlogo = this.imageUrl
         }
         if (this.imageUrl2) {
           params.navigationlogo = this.imageUrl2
         }
         if (this.imageUrl3) {
           params.zoomlogo = this.imageUrl3
         }
         fetch({
           url: "hcm/userout/updatehcmlogo",
           method: "post",
           params: params,
           noFormat: true,
           responseType: "text"
         }).then(result => {
           let res = JSON.parse(result);
           let {data}=res
           if(res.status == '10000'){
             this.logoshow = false
             this.selecthcmlogo();
           } else {
             this.$message.error(res.message);
           }
         })
       } else {
         this.logoshow = false
         this.uploadDisabled= true
         this.uploadDisabled2= true
         this.uploadDisabled3= true
       }
     },
     GetList() {
       let params={
         dictcode: 'version',
       }
       fetch({
         url: "hcm/sys/GetList",
         method: "get",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           this.dict = data
         } else {
           this.$message.error(res.message);
         }
       })
     },
     businessSetting(e) {
       let that = this
       if (e == 1) {
         let params={
           productmonitorFrequency: this.productmonitorFrequency,
           shopmonitorFrequency: this.shopmonitorFrequency,
           productmonitorSnapshot: this.productmonitorSnapshot,
           shopmonitorSnapshot: this.shopmonitorSnapshot,
           productmonitorPlatform: this.productmonitorPlatform.join(","),
           shopmonitorPlatform: this.shopmonitorPlatform.join(","),
           productmonitorDimensionality: this.productmonitorDimensionality,
           singlelinkPlatform: this.singlelinkPlatform.join(","),
           dateplatform: this.dateplatform.join(","),
           singlelinkSnapshot: this.singlelinkSnapshot,
           singlelinkDimensionality: this.singlelinkDimensionality,
           spiderId: Number(this.spiderId),
           dateplatformStatus: Number(this.dateplatformStatus),
           databoardStatus: Number(this.databoardStatus),
           dataloginStatus: Number(this.dataloginStatus),
           majorproducts: Number(this.majorproducts),
           screenshotStatus: Number(this.screenshotStatus),
           couponstype: Number(this.couponstype),
           bmcid: this.$route.query.bmcid,
         }
         if (this.productmonitorNumber == '') {
           this.productmonitorNumber = 0
         } else {
           params.productmonitorNumber = this.productmonitorNumber
         }
         if (this.shopmonitorNumber == '') {
           this.shopmonitorNumber = 0
         } else {
           params.shopmonitorNumber = this.shopmonitorNumber
         }

         if (this.singlelinkNumber == '') {
           this.singlelinkNumber = 0
         } else {
           params.singlelinkNumber = this.singlelinkNumber
         }
         if (this.productcheckpriceNumber == '') {
           this.productcheckpriceNumber = 0
         } else {
           params.productcheckpriceNumber = this.productcheckpriceNumber
         }
         axios({
            method: 'post',
            url: 'hcm/cus/updateBusinessPermissions',
            headers: {
              'Content-type': 'application/json;charset=UTF-8'
            },
            data: params,
         }).then(function (response) {
           if (response.data.status == "10000") {
             that.$message({
               message: '保存成功',
               type: 'success'
             });
             that.businessSettingShow = false
             that.settingDisabled = true
             that.selectbmcCampaigntype()
           } else {
             that.$message.error(response.data.message)
           }
         })
       } else {
         that.selectbmcCampaigntype()
         this.businessSettingShow = false
         that.settingDisabled = true
       }
     },
     domainNameUp(e) {
       if (e == 1) {
         let params={
           bmcid: this.$route.query.id,
         }
         if (this.domainname) {
           params.domainname = this.domainname
         }
         if (this.imageUrl) {
           params.loginlogo = this.imageUrl
         }
         if (this.imageUrl2) {
           params.navigationlogo = this.imageUrl2
         }
         if (this.imageUrl3) {
           params.zoomlogo = this.imageUrl3
         }
         fetch({
           url: "hcm/userout/updatehcmlogo",
           method: "post",
           params: params,
           noFormat: true,
           responseType: "text"
         }).then(result => {
           let res = JSON.parse(result);
           let {data}=res
           if(res.status == '10000'){
             this.domainDisble = true
             this.brandshow = false
             this.selecthcmlogo();
           } else {
             this.$message.error(res.message);
           }
         })
       } else {
         this.domainDisble = true
         this.brandshow = false
       }
     },
     picRequest(a){
       let that = this;
       var formdata=new FormData()
       formdata.append('file',a.file)
       let config={
         headers:{
             'Content-Type':'multipart/form-data'
         }
       }
       const instance=axios.create({
         withCredentials: true
       })
       instance.post("hcm/hcmWorkOrder/headImgUpload", formdata,config).then(function(res) {
         let {data}=res
         that.imageUrl = data.data.data;
       });
     },
     picRequest2(a){
       let that = this;
       var formdata=new FormData()
       formdata.append('file',a.file)
       let config={
         headers:{
             'Content-Type':'multipart/form-data'
         }
       }
       const instance=axios.create({
         withCredentials: true
       })
       instance.post("hcm/hcmWorkOrder/headImgUpload", formdata,config).then(function(res) {
         let {data}=res
         that.imageUrl2 = data.data.data;
       });
     },
     picRequest3(a){
       let that = this;
       var formdata=new FormData()
       formdata.append('file',a.file)
       let config={
         headers:{
             'Content-Type':'multipart/form-data'
         }
       }
       const instance=axios.create({
         withCredentials: true
       })
       instance.post("hcm/hcmWorkOrder/headImgUpload", formdata,config).then(function(res) {
         let {data}=res
         that.imageUrl3 = data.data.data;
       });
     },
     handleAvatarSuccess(res, file) {
       this.imageUrl = URL.createObjectURL(file.raw);
     },
     handleAvatarSuccess2(res, file) {
       this.imageUrl2 = URL.createObjectURL(file.raw);
     },
     handleAvatarSuccess3(res, file) {
       this.imageUrl3 = URL.createObjectURL(file.raw);
     },
     beforeAvatarUpload(file) {
       const isLt2M = file.size / 1024 / 1024 < 2;
       if (!isLt2M) {
         this.$message.error('上传头像图片大小不能超过 2MB!');
       }
       return isLt2M;
     },
     beforeAvatarUpload2(file) {
       const isLt2M = file.size / 1024 / 1024 < 2;
       if (!isLt2M) {
         this.$message.error('上传头像图片大小不能超过 2MB!');
       }
       return isLt2M;
     },
     beforeAvatarUpload3(file) {
       const isLt2M = file.size / 1024 / 1024 < 2;
       if (!isLt2M) {
         this.$message.error('上传头像图片大小不能超过 2MB!');
       }
       return isLt2M;
     },
     Editor(e) {
       if (e == 1) {
         this.iprEditorshow = true
         this.iprdisabled = false
       } else if (e == 2) {
         this.brmEditorshow = true
         this.brmDisabled = false
       } else if (e == 3) {
         this.brandshow = true
         this.domainDisble = false
       } else if (e == 4)  {
         this.logoshow = true
         this.uploadDisabled = false
         this.uploadDisabled2 = false
         this.uploadDisabled3 = false
       } else {
         this.businessSettingShow = true
         this.settingDisabled = false
       }
     },
     selecthcmlogo() {
       let params={
         bmcid: this.$route.query.id,
       }
       fetch({
         url: "hcm/userout/selecthcmlogo",
         method: "get",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           this.domainname = data.domainname;
           this.imageUrl = data.loginlogo;
           this.imageUrl2 = data.navigationlogo;
           this.imageUrl3 = data.zoomlogo;
         } else {
           this.$message.error(res.message);
         }
       })
     },
     showBusiness() {
       let params={
         bmcid: this.$route.query.id,
       }
       fetch({
         url: "hcm/complaiont/getAccountListByBmcid",
         method: "get",
         params: params,
         noFormat: true,
         responseType: "text"
       }).then(result => {
         let res = JSON.parse(result);
         let {data}=res
         if(res.status == '10000'){
           if (data.brmkefu) {
             this.brmkefu2 = data.brmkefu.split(",");
             for(let i=0;i<this.brmkefu2.length;i++){
               this.brmkefu.push(Number(this.brmkefu2[i]))
             }
           }
           console.log(this.brmkefu)
           if (data.iprkefu) {
             this.iprkefu2 = data.iprkefu.split(",");
             for(let i=0;i<this.iprkefu2.length;i++){
               this.iprkefu.push(Number(this.iprkefu2[i]))
             }
           }
           if (data.jdaccount) {
             this.jdaccount = data.jdaccount;
             this.jdaccount2 = this.jdaccount.split(",");
             for(let i=0;i<this.jdaccount2.length;i++){
               this.JDcomplaiontId.push(Number(this.jdaccount2[i]))
             }
           }
           if (data.tbaccount) {
             this.tbaccount = data.tbaccount;
             this.tbaccount2 = this.tbaccount.split(",");
             for(let i=0;i<this.tbaccount2.length;i++){
               this.ALcomplaiontId.push(Number(this.tbaccount2[i]))
             }
           }
           this.validtimebrm = data.validtimebrm;
           this.validtimeipr =  data.validtimeipr;
           this.version = data.version;
           this.getIPRList();
           this.getBRMList();
         } else {
           this.$message.error(res.message);
         }
       })
     },
   }
 }
</script>
<style scoped lang="scss">
 .header {
   width: 100%;
   height: 40px;
   background-color: white;
 }
 .page {
   padding: 20px;
   margin: 20px;
   background-color: white;
 }
 .iconDiv {
   width: 5px;
   background-color: #333333;
   margin-right: 10px;
   height: 21px;
   margin-top: 4px;
 }
 .headerSize {
   line-height: 40px;
   text-align: right;
 }
 .titleFont {
   font-size: 20px;
   font-weight: 600;
   width: 100%;
 }
 .theTitle {
   font-size: 16px;
   font-weight: 500;
 }
 .box-card {
   height: 313px;
   margin-top: 15px;
   overflow-y: auto;
 }
 .avatar-uploader .el-upload {
   border: 1px dashed #d9d9d9;
   border-radius: 6px;
   cursor: pointer;
   position: relative;
   overflow: hidden;
 }
 .avatar-uploader .el-upload:hover {
   border-color: #409EFF;
 }
 .avatar-uploader-icon {
   font-size: 28px;
   color: #8c939d;
   width: 178px;
   height: 178px;
   line-height: 178px;
   text-align: center;
 }
 .avatar {
   width: 178px;
   height: 178px;
   display: block;
 }
</style>
<style lang="scss">
#BrandSet {
  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
 .divbf {
   width: 33%;
   float: left;
   text-align: left;
   margin-bottom: 10px;
 }
 .divClass {
   width: 100px;
   height: 60px;
   line-height: 60px;
   text-align: center;
   float: left;
   border: 1px solid #bda571;
   border-radius: 5px;
   margin-right: 20px;
 }
 .smallDiv {
   width: 80%;
 }
 .el-table th {
   background-color: #f3f7ff !important;
 }
 #dialog {
   .el-dialog__header {
     padding: 20px 20px 10px;
     border-bottom: 1px solid #d9d9d9;
   }
 }
 .el-button+.el-button {
   margin-left: 1px;
 }
 .el-button--TheCustom {
   color: #666;
   border-color: #D9D9D9;
   background-color: #fff;
 }
 .el-button--TheCustom:hover  {
   color: #666;
   border-color: #ded2b8;
   background-color: #faf9f5;
 }
 .el-button--primary {
   color: #FFF;
   background-color: #bda571;
   border-color: #bda571;
 }
 .el-button--primary:hover {
   color: #FFF;
   background-color: #c0ae8a;
   border-color: #c0ae8a;
 }
 .el-radio__input.is-checked .el-radio__inner {
   border-color: #bda571;
   background: #bda571;
 }
 .el-radio__input.is-checked+.el-radio__label {
   color: #666;
 }
 .el-radio__inner:hover {
   border-color: #bda571;
 }
 .avatar-uploader .el-upload {
   border: 1px dashed #d9d9d9;
   border-radius: 6px;
   cursor: pointer;
   position: relative;
   overflow: hidden;
 }
}
</style>
